const keySuffix = 'temp_profile_photo'
const store = globalThis.localStorage

function key(owner) {
  return `${owner}_${keySuffix}`
}

function setTempProfilePhoto(owner, src) {
  store.setItem(key(owner), src)
}

export { setTempProfilePhoto }
